import axios from 'axios'
import departmentLookup from './departments.js'

// Public API Endpoint on Socrata
const api = '/assets/prebuilt/vue/rsji-equity-actions/tzm9-n65h.json'
const apiBKUP = '/assets/prebuilt/vue/rsji-equity-actions/tzm9-n65h.json'
// const api = '/assets/prebuilt/vue/rsji-equity-actions/merged.json'
// const apiBKUP = '/assets/prebuilt/vue/rsji-equity-actions/merged.json'

let filters = {}

const getData = async () => {
  try {
    const { data } = await axios.get(api)
    return data
  } catch (err) {
    console.log('RSJI Actions Primary Failed')
    // console.log(err);
    try {
      const { data } = await axios.get(apiBKUP)
      return data
    } catch (err) {
      console.log('RSJI Actions Secondary Failed')
      // console.log(err);
      return []
    }
  }
}

const generateLink = (id, title) => {
    // //www.seattle.gov/rsji/department-portal-page/#/[Socrata ID]/[Action Title]
    // Check if Socrata ID changes on data publish 
    let page = window.location.href.split('#')[0]

    let cleanTitle = title.toLowerCase().trim()

    // Strip quotes, commas, periods, hashes
    cleanTitle = cleanTitle.replace(/"|%26|%27|%28|%29|,|\\|\/|\?|\.|#/g, '');
    // Remove spaces
    cleanTitle = cleanTitle.replace(/\s-\s|\s+/g, '-');
      
    let url = page + '#/action/' +  id + '/' + cleanTitle

    return url
}

const decodeString = string => {
  const encodings = {
    '%26':'&',
    '%27':'\'',
    '%28':'(',
    '%29':')',
  }

  for (const property in encodings) {
    string = string.replace(new RegExp(property, 'g'), encodings[property])
  }

  return string
}

const getActions = async () => {
  let rawActions = await getData()
  console.log('Actions: ', rawActions)

  rawActions = rawActions.filter(action => action.title.toLowerCase() != 'test');

  for (let action of rawActions) {
    // Create router link
    action.route = generateLink(action.id, action.title)

    // Add Departments & Icons
    const department = departmentLookup.find(x => x.socrataName == action.equity_plan)
    action.department = (department) ? department.name : ''
    action.icon = (department) ? department.icon : 'dept-not-found'

    // Remove URL encoding of columns
    for (const property in action) {
      let value = action[property]

      if (typeof(value) == 'string') {
        action[property] = decodeString(value)
      }
    }

    // Get Years
    action.active_years = action.active_years?.replace(/\[|\]|"/g, '');
    action.years = action.active_years?.split(',')
    action.years_range = (action.years.length < 2) ? action.years.join('') : `${action.years[0]}-${action.years[action.years.length - 1]} `

    // Create Arrays from *** delimited items
    action.major_deliverables = action.major_deliverables?.trim().split('***').filter(n => n) || []
    action.public_engagement = action.public_engagement?.trim().split('***').filter(n => n) || []
    action.outcome_measurement = action.outcome_measurement?.trim().split('***').filter(n => n) || []
    // action.rsj_indicators = action.rsj_indicators?.trim().split(';#').filter(n => n) || []

    // console.log(action.timeline, action.years)

    // Remove unnecessary columns of data
    // delete action[':created_at']
    // delete action[':updated_at']
    // delete action[':version']
    delete action.active_years
    delete action.deprecatedtimeline
    delete action.path
    delete action.item_path
    delete action.created
    delete action.created_by
    delete action.equity_plan_division
    delete action.community_outcome_1_id
    delete action.community_outcome_2_id
  }

 

  const topics = [... new Set(
        rawActions.map(x => 
          x.community_outcome_1_title || 
          x.community_outcome_2_title 
        )
      )].sort(),
      departments = [... new Set(
        rawActions.map(x => x.department).filter(n => n)
      )].sort(),
      timeline = [... new Set(
          rawActions.map(x => x.years).flat(1)
      )].sort()

  filters = {
    topics,
    departments,
    timeline
  }

  // console.log('Filters: ', filters)
  // console.log('Topic Filters: ', topics)
  // console.log('Department Filters: ', departments)
  // console.log('Timeline Filters: ', timeline)

  return {
    actions: rawActions,
    filters
  }
}


export default {
  getActions,
}


